<template>
  <div>
    <navigation-dialog v-if="isOpen('stackBoard')" title="QR 코드 스캔" use-close @close="closeAll">
      <qr-scan-board @click="(item) => { next('stackField', item) }"/>
    </navigation-dialog>

    <navigation-dialog v-if="isOpen('stackField')" :title="getStackData('stackBoard').title" use-close use-back @back="close" @close="closeAll">
      <qr-scan-field ref="stackField" @click="(item) => { next('stackCamera', item) }"/>
    </navigation-dialog>

    <navigation-dialog v-if="isOpen('stackCamera')" title="QR 코드 스캔" use-close use-back @back="close" @close="closeAll">
      <qr-scan-camera ref="stackCamera" @back="close" @success="qrScanSuccess"/>
    </navigation-dialog>

    <navigation-dialog v-if="isOpen('stackCheckInOut') && getStackData('stackCamera')" :title="`${getStackData('stackField').field_name} QR 코드 스캔`" use-close use-back @back="close" @close="closeAll">
      <qr-scan-check-in-out ref="stackCheckInOut"
                            :data="{
                              user_name: getStackData('stackCamera').data.user.name,
                              field_name: getStackData('stackField').field_name,
                              com_name: getStackData('stackCamera').data.user.company.com_name,
                              rank: getStackData('stackCamera').data.user.rank,
                              section: getStackData('stackCamera').data.user.section,
                            }"
                            @checkIn="checkIn"
                            @checkOut="checkOut"
      />
    </navigation-dialog>
  </div>
</template>

<script>
import NavigationDialog from "@/components/dialog/NavigationDialog.vue";
import QrScanBoard from "@/layouts/components/navbar/components/qr-scan-manager/QrScanBoard.vue";
import QrScanField from "@/layouts/components/navbar/components/qr-scan-manager/QrScanField.vue";
import QrScanCamera from "@/layouts/components/navbar/components/qr-scan-manager/QrScanCamera.vue";
import HttpRequest from "@/util/HttpRequest";
import QrScanCheckInOut from "@/layouts/components/navbar/components/qr-scan-manager/QrScanCheckInOut.vue";

export default {
  name: 'QrScanManager',
  components: {QrScanCheckInOut, QrScanCamera, QrScanField, QrScanBoard, NavigationDialog},
  props: {
    userId: {
      type: [String, Number],
      default: 'guest'
    }
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    lastStack() {
      return this.stack.length > 0 ? this.stack[this.stack.length - 1] : null;
    },
    lastStackData() {
      return this.lastStack ? this.stackData[this.lastStack] : null;
    }
  },
  data() {
    return {
      stack: [], // ['stackBoard', 'stackField']
      stackData: {},
    };
  },
  methods: {
    getStackData(stackName) {
      return this.stackData[stackName] || {};
    },
    open(name, data) {
      if (!name) {
        name = 'stackBoard';
      }
      if (data) {
        this.stackData[this.lastStack] = data;
      }
      this.stack.push(name);
      history.pushState({ popup: name }, '', window.location.href);
    },
    next(name, data) {
      this.open(name, data);
      this.$nextTick(args => {
        if (name === 'stackField') {
          this.$refs.stackField.loadField();
        } else if (name === 'stackCamera') {
          this.$refs.stackCamera.openDialog();
        }
      })
    },
    close() {
      this.stack.pop();
    },
    closeAll() {
      const count = this.stack.length;
      this.stack = [];

      // 뒤로가기 이벤트를 유도하기 위한 방법 (선택 1)
      for (let i = 0; i < count; i++) {
        history.back();
      }

      // 또는 그냥 상태 초기화만 한다면 (선택 2)
      // history.go(-count);
    },
    isOpen(name) {
      return this.stack.includes(name);
    },
    onPopState() {
      this.close(); // 하나 제거
    },
    qrScanSuccess(qr) {
      const option = {
        project_id: this.projectId,
        qr
      }
      HttpRequest.post(`/api/v1/project/qr/${this.projectId}/pre`, option)
        .then((response) => {
          if (response && response.success) {
            this.next('stackCheckInOut', response);
          }
        })
        .catch((err) => {
          try {
            if (err.response.data) {
              const errMessage = err.response.data.error.message
              const customAlert = new CustomEvent("customAlert", {
                detail: {
                  title: "오류가 발생했습니다",
                  message: errMessage,
                  cancelFunction: () => {
                    // 오류 발생시 스캔 다시 시작
                    this.$refs.stackCamera.startAutoScan()
                  }
                },
              });
              window.dispatchEvent(customAlert);
            }
          } catch (e) {
            alert("QR 스캔 중 오류가 발생했습니다")
          }
        });
    },
    checkIn() {
      this.sendCheckInOut("출근", (message) => {
        const customAlert = new CustomEvent("customAlert", {
          detail: {
            title: "출근 완료",
            message,
            cancelFunction: () => {
              this.$refs.stackCamera.startAutoScan()
              // 출근 버튼 누른후 팝업 닫힘
              this.close();
            }
          },
        });
        window.dispatchEvent(customAlert);
      });
    },
    checkOut() {
      this.sendCheckInOut("퇴근", (message) => {
        const customAlert = new CustomEvent("customAlert", {
          detail: {
            title: "퇴근 완료",
            message,
            cancelFunction: () => {
              this.$refs.stackCamera.startAutoScan()
              // 퇴근 버튼 누른후 팝업 닫힘
              this.close();
            }
          },
        });
        window.dispatchEvent(customAlert);
      });
    },
    sendCheckInOut(data, callBack) {
      const option = {
        project_id: this.projectId,
        verified: this.getStackData('stackCamera').verified,
        data, //출근, 퇴근
        meta: JSON.stringify({
          bid: this.getStackData("stackBoard").boardId, // boardId
          fid: this.getStackData("stackField").id, // fieldId
          pid: undefined, // postId
          rid: undefined, // RegionId
          zid: undefined, // ZoneId
        })
      }
      HttpRequest.post(`/api/v1/project/qr/${this.projectId}/modify`, option)
        .then((response) => {
          if (response && response.success) {
            if (callBack) {
              callBack(response.message)
            }
          }
        })
        .catch((err) => {
          console.log("err", err)
        });
    }
  },

  mounted() {
    window.addEventListener('popstate', this.onPopState);
  },
  beforeDestroy() {
    window.removeEventListener('popstate', this.onPopState);
  },
};
</script>

<style lang="scss" scoped>
</style>
